{
  "documents": {
    "title": "Corporate Vault",
    "subtitle": "Management of your institutional and legal assets.",
    "actions": {
      "generate_statutes": "Generate Statutes",
      "upload": "Upload",
      "view": "View",
      "download": "Download",
      "share": "Share",
      "delete": "Delete",
      "request_doc": "Request Document"
    },
    "filters": {
      "all": "All Documents",
      "legal": "Legal & Statutes",
      "finance": "Financial Records",
      "tax": "Tax Declarations",
      "hr": "Human Resources",
      "administrative": "Administrative"
    },
    "search": "Search for a document...",
    "table": {
      "name": "Document Name",
      "type": "Type",
      "date": "Date Added",
      "status": "Status",
      "size": "Size"
    },
    "status": {
      "verified": "Verified",
      "pending": "Pending Audit",
      "draft": "Draft",
      "expired": "Expired",
      "archived": "Archived"
    },
    "empty": {
      "title": "No documents found",
      "subtitle": "Upload your first document or generate statutes to start.",
      "cta": "Upload Document"
    },
    "upload": {
      "title": "Upload Document",
      "dropzone": "Click or drag file to this area to upload",
      "hint": "Support for PDF, JPG, PNG (Max 10MB)",
      "processing": "Analyzing document structure...",
      "success": "Document uploaded and indexed."
    }
  },
  "common": {
    "not_defined": "Not Defined",
    "not_available": "N/A",
    "previous": "Previous",
    "back": "Back",
    "next": "Next",
    "save": "Save",
    "processing": "Processing...",
    "saved": "Saved",
    "export_success": "Report exported successfully",
    "currency": "DA",
    "error": {
      "title": "Critical System Error",
      "description": "The module could not be loaded correctly. Technical detail:",
      "reset": "Reset Module"
    },
    "link_copied": "Link copied to clipboard",
    "options": {
      "yes": "YES",
      "no": "NO",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "retry": "Retry"
    },
    "new": "New",
    "locale": "en-US",
    "loading": "Chargement...",
    "confirm": "Confirmer"
  },
  "dashboard": {
    "title": "Company Management",
    "subtitle": "Strategic control for the modern enterprise.",
    "pdf": {
      "title": "CORPORATE LEGAL DOSSIER",
      "date": "Date",
      "ref": "Reference",
      "sections": {
        "identity": "1. COMPANY IDENTITY",
        "governance": "2. GOVERNANCE & STRUCTURE",
        "history": "LEGAL ACTION HISTORY"
      },
      "table": {
        "field": "Field",
        "info": "Information",
        "role": "Role",
        "entity_person": "Entity/Person",
        "status": "Status",
        "date": "Date",
        "action_type": "Action Type",
        "summary": "Summary"
      },
      "fields": {
        "legal_name": "Denomination",
        "legal_form": "Legal Form",
        "nif": "NIF",
        "rc": "RC",
        "capital": "Share Capital",
        "headquarters": "Headquarters",
        "manager": "Manager",
        "associates": "Partners",
        "active": "Active",
        "registered": "Registered",
        "members": "{{count}} Members"
      },
      "defaults": {
        "modification": "Corporate modification registered.",
        "ledger": "Official act recorded."
      },
      "filename_suffix": "dossier"
    },
    "stats": {
      "active_projects": "Active Projects",
      "compliance_rate": "Compliance Rate",
      "legal_events": "Legal Events",
      "next_audit": "Next Audit",
      "legal_form": "Legal Form",
      "capital": "Share Capital",
      "governance": "Governance",
      "location": "Location",
      "active_associates": "Active Partners",
      "official_identity": "Official Identity",
      "verified_registry": "Verified at the National Trade Registry",
      "tax_status": "G50 Tax Status Up to Date",
      "legal_status": "Authenticated Bylaws",
      "title": "Data Insights",
      "age": "Company Age",
      "years": "{{count}} Years",
      "established": "Established",
      "secure": "Secure",
      "no_manager": "No Manager",
      "compliance": "Compliance"
    },
    "grid": {
      "simulator": {
        "title": "Fiscal & Social Simulator",
        "desc": "Simulate and optimize your company structure before launching."
      },
      "name_check": {
        "title": "Trademark Check",
        "desc": "Verify brand availability and legal conflict risks."
      },
      "create": {
        "title": "Company Creation",
        "desc": "Unified workflow for administrative and legal setup."
      },
      "documents": {
        "title": "Corporate Vault",
        "desc": "Access and manage all your institutional documents."
      }
    },
    "journal": {
      "title": "Corporate Ledger",
      "empty": "No events recorded"
    },
    "actions": {
      "search_placeholder": "Search for a legal action...",
      "download_dossier": "Corporate Dossier (PDF)",
      "hq_transfer": {
        "title": "Headquarters Transfer",
        "desc": "Official change of legal address."
      },
      "capital_update": {
        "title": "Capital Variation",
        "desc": "Increase or decrease share capital."
      },
      "form_change": {
        "title": "Legal Form Change",
        "desc": "Convert to SARL, SPA or EURL."
      },
      "manager_update": {
        "title": "Manager Appointment",
        "desc": "Change or renew management."
      },
      "dissolution": {
        "title": "Company Dissolution",
        "desc": "Formal decision to cease activity."
      },
      "liquidation": {
        "title": "Radiation & Liquidation",
        "desc": "Final closure and deregistration."
      },
      "associates": {
        "title": "Partners Management",
        "desc": "Update shareholding and entries."
      },
      "object": {
        "title": "Social Object",
        "desc": "Modify company activities."
      },
      "cnrc_portal": "CNRC Portal"
    },
    "legal": {
      "title": "Legal Operations"
    },
    "vault": {
      "title": "Corporate Vault"
    },
    "toasts": {
      "titles": {
        "success": "Success",
        "error": "Error",
        "info": "Information",
        "warning": "Warning"
      },
      "generating_pdf": "Synchronizing data and generating PDF...",
      "pdf_success": "Legal dossier exported successfully.",
      "pdf_error": "Failed to generate the digital dossier.",
      "hq_transfer_success": "Headquarters transfer recorded.",
      "capital_update_success": "Capital variation confirmed.",
      "form_change_success": "Legal form updated successfully.",
      "manager_update_success": "Manager appointment registered.",
      "dissolution_success": "Dissolution act generated.",
      "liquidation_success": "Liquidation completed.",
      "associates_success": "Company partners registry updated.",
      "object_success": "Social object amendment registered.",
      "action_error": "An error occurred during processing.",
      "load_failed": "Unable to synchronize company data.",
      "wizard_success": "Legal procedure registered and history updated.",
      "wizard_error": "An error occurred while executing the procedure."
    },
    "events": {
      "title": "Action Center",
      "journal": "Journal",
      "view_all": "View All",
      "no_history": "No history available",
      "types": {
        "compliance": "Compliance",
        "tax": "Taxation",
        "security": "Security",
        "creation": "Initial Registration",
        "capital_increase": "Capital Increase",
        "headquarters_transfer": "HQ Transfer",
        "legal_form_change": "Form Change",
        "partner_addition": "Partner Addition",
        "manager_update": "Manager Change",
        "associates_update": "Partners Update",
        "dissolution": "Dissolution Decision",
        "liquidation_started": "Liquidation Started",
        "liquidation_completed": "Radiation Confirmed",
        "certificate_generation": "Document Issuance"
      },
      "descriptions": {
        "creation": "Initial registration.",
        "capital_increase": "Capital: {{amount}} DZD",
        "headquarters_transfer": "Headquarters: {{address}}",
        "legal_form_change": "Form: {{form}}",
        "partner_addition": "New Partner: {{name}}",
        "manager_update": "New Manager: {{name}}",
        "associates_update": "Ownership structure updated ({{count}} partners).",
        "dissolution": "Dissolution decision.",
        "liquidation_started": "Company entered liquidation phase.",
        "liquidation_completed": "Deregistration confirmed.",
        "certificate_generation": "Official certificate issued."
      },
      "statuses": {
        "completed": "Completed",
        "pending": "Pending",
        "draft": "Draft",
        "active": "Active",
        "archived": "Archived"
      }
    },
    "loading": {
      "engine": "Synchronizing Legal Engine..."
    },
    "statuses": {
      "liquidation": "Liquidation",
      "dissolved": "Dissolved",
      "active": "Active"
    },
    "empty_state": {
      "title": "No Legal Entity Detected",
      "description": "You must have an active company to access the <1>Legal Lifecycle Manager</1>.",
      "cta": "Register a company"
    },
    "wizard": {
      "steps": {
        "structure": "Structure & Capital",
        "review": "Review & Validation",
        "execution": "Confirm & Execute"
      },
      "messages": {
        "finalizing": "Finalizing procedure and updating ledger..."
      },
      "fields": {
        "configuration": "Procedure Configuration",
        "new_address": "New Legal Address",
        "address": "Address",
        "address_placeholder": "Enter full address",
        "wilaya": "City / Wilaya",
        "wilaya_placeholder": "Algiers",
        "type": "Type",
        "lease": "Commercial Lease",
        "property": "Property",
        "new_capital": "New Share Capital (DZD)",
        "new_form": "New Legal Form",
        "new_manager": "New Manager Name",
        "capital_placeholder": "ex: 1 000 000",
        "current": "Current",
        "fullname": "Full Name",
        "fullname_placeholder": "First and Last Name",
        "shares": "Shares (%)",
        "shares_placeholder": "25",
        "role": "Role",
        "associate": "Partner",
        "manager": "Manager",
        "director_general": "Director General",
        "default_reason": "Unanimous decision of the partners",
        "default_wilaya": "Algiers",
        "legal_form_desc": {
          "SARL": "Multiple Partners",
          "EURL": "Single Partner",
          "SPA": "Institutional",
          "SAS": "Flexible"
        }
      },
      "warnings": {
        "critical_action": "CRITICAL ACTION",
        "irrevocable": "This action is irrevocable and will be recorded in the official journal.",
        "irreversible": "Irreversible Action",
        "irreversible_desc": "This action will permanently end the company's activity."
      },
      "placeholders": {
        "generic_config": "No specific configuration required for this act.",
        "no_changes": "No changes detected in the current configuration."
      },
      "buttons": {
        "confirm_understanding": "I understand and I confirm",
        "confirmed": "Confirmed",
        "processing": "Processing...",
        "finish": "Finish and Save"
      },
      "validation": {
        "statutory": "Statutory Compliance",
        "cnrc": "Trade Registry (CNRC)",
        "tax": "Tax Eligibility",
        "valid": "VALID",
        "compliant": "COMPLIANT",
        "ready": "READY",
        "ready_signature": "Ready for Signature",
        "no_blockage": "No legal blockage detected."
      },
      "execution": {
        "title": "Confirm & Execute",
        "desc": "Update data and generate certificates."
      },
      "errors": {
        "address_required": "Exact address is required",
        "capital_invalid": "Invalid capital amount",
        "form_required": "Select a valid legal form",
        "name_required": "Partner name required",
        "confirm_dissolution": "Please confirm the dissolution decision",
        "confirm_liquidation": "Please confirm the liquidation closure"
      },
      "toasts": {
        "recorded_title": "Act Recorded",
        "recorded_msg": "The modification has been recorded in the company registry.",
        "failed_title": "Control Failed",
        "missing_field": "Missing Field"
      }
    },
    "dossier_pdf": {
      "title": "DIGITAL COMPANY DOSSIER",
      "generated_at": "Generated on {{date}}",
      "identity": {
        "title": "1. COMPANY IDENTITY",
        "name": "Denomination:",
        "legal_form": "Legal Form:",
        "capital": "Share Capital:",
        "hq": "Headquarters:",
        "unspecified": "Unspecified"
      },
      "governance": {
        "title": "2. GOUVERNANCE AND PARTNERS",
        "header_name": "Name",
        "header_role": "Role",
        "header_shares": "Shares",
        "header_contribution": "Contribution",
        "role_manager": "Manager",
        "role_gm": "General Manager",
        "role_partner": "Partner",
        "empty": "No registered partners"
      }
    },
    "errors": {
      "address_required": "L'adresse exacte est requise",
      "capital_invalid": "Montant du capital invalide",
      "form_required": "Sélectionnez une forme juridique valide",
      "name_required": "Nom de l'associé requis",
      "confirm_dissolution": "Veuillez confirmer la décision de dissolution",
      "confirm_liquidation": "Veuillez confirmer la clôture de liquidation"
    }
  },
  "simulator": {
    "structures": {
      "EURL": {
        "label": "EURL",
        "description": "Single-Person Limited Liability Company"
      },
      "SARL": {
        "label": "SARL",
        "description": "Limited Liability Company"
      },
      "SPA": {
        "label": "SPA",
        "description": "Joint Stock Company"
      },
      "SAS": {
        "label": "SAS",
        "description": "Simplified Joint Stock Company"
      },
      "SNC": {
        "label": "SNC",
        "description": "General Partnership"
      },
      "INDIVIDUELLE": {
        "label": "Sole Proprietorship",
        "description": "Individual Activity without Legal Entity"
      }
    },
    "title": "Fiscal & Social Simulator",
    "subtitle": "Configure your structure in 4 simple steps.",
    "steps": {
      "project": "Your Project",
      "project_desc": "Let's start with the basics of your future activity.",
      "structure": "Structure & Capital",
      "structure_desc": "Define the size and resources of your entity.",
      "vision": "Vision & Risks",
      "vision_desc": "Refine the strategic objectives of the simulation.",
      "ready": "Configuration Ready",
      "ready_desc": "Verify your settings before running the arbitration."
    },
    "fields": {
      "activity_sector": "Activity Sector",
      "simulation_mode": "Simulation Mode",
      "partners": "Partners Count",
      "partner_label": "Partner",
      "partners_label": "Partners",
      "capital": "Starting Capital (DA)",
      "objective": "Main Objective",
      "risk": "Estimated Risk",
      "investors": "Investors?",
      "currency": "DA"
    },
    "options": {
      "services": "Services",
      "commerce": "Commerce",
      "industry": "Industry",
      "artisanat": "Craftsmanship",
      "startup": "Tech / Startup",
      "standard": "Standard (Legal)",
      "premium": "Premium (Soon)",
      "growth": "Fast Growth",
      "growth_desc": "Focus on expansion and market share",
      "stability": "Security & Stability",
      "stability_desc": "Maximum asset protection",
      "tax_optimization": "Tax Optimization",
      "tax_optimization_desc": "Reduction of the tax burden",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      "yes": "YES",
      "no": "NO"
    },
    "summary": {
      "activity": "Activity",
      "partners": "Partners",
      "capital": "Initial Capital",
      "priority": "Priority"
    },
    "buttons": {
      "reset": "Reset",
      "calculate": "Calculate Indicators",
      "previous": "Previous",
      "continue": "Continue",
      "run": "Launch Simulation",
      "executing": "Executing..."
    },
    "footer": {
      "certification": "AI Decision Support System — Certified DZ_LAW_2025"
    },
    "info": "By running this simulation, our engine will process 150+ legal variables based on the Algerian Commercial Code to propose the optimal structure.",
    "engine": {
      "forms": {
        "EURL": {
          "name": "EURL",
          "desc": "Single-person LLC. Ideal for solo founders wanting limited liability."
        },
        "SARL": {
          "name": "SARL",
          "desc": "Limited Liability Company. Standard for multiple partners with protected assets."
        },
        "SPA": {
          "name": "SPA",
          "desc": "Joint Stock Company. Designed for large capital and outside investors."
        },
        "SAS": {
          "name": "SAS",
          "desc": "Simplified Joint Stock Company. Flexible governance, great for startups."
        },
        "SNC": {
          "name": "SNC",
          "desc": "General Partnership. Infinite joint liability, suited for high-trust family businesses."
        },
        "INDIVIDUELLE": {
          "name": "Sole Proprietorship",
          "desc": "Simple setup, but infinite personal liability."
        }
      },
      "reasons": {
        "partners_min": "The number of partners is less than the legal minimum.",
        "partners_max": "The number of partners exceeds the legal maximum.",
        "capital_min": "The capital is less than the legal minimum required.",
        "capital_ok": "The share capital complies with legal requirements.",
        "risk_limited": "Limited liability is ideal for your risk appetite.",
        "risk_unlimited": "Unlimited liability: high risk for your personal assets.",
        "risk_incompatible": "High risk: your personal assets are not protected.",
        "investor_ready": "Ability to welcome institutional investors.",
        "investor_unready": "Structure not well-suited for external investors.",
        "partners_ok": "Number of partners is compliant.",
        "protected_assets": "Your personal assets are legally protected.",
        "startup_framework": "Legal framework specifically tailored for labeled Startups.",
        "partners_1": "Structure optimized for a single founder.",
        "partners_multi": "Governance designed for multiple partners.",
        "partners_spa_min": "Meets the minimum requirement of 7 partners for an SPA.",
        "capital_1m": "Capital meets the institutional threshold (> 1M DZD).",
        "capital_100k": "Standard capital for an LLC (> 100k DZD).",
        "tax_opt": "Fiscal regime optimized for this activity sector.",
        "asset_shield": "Full legal separation of personal and professional assets.",
        "investor_fit": "Scalable equity structure for external fundraising.",
        "growth_engine": "Flexible governance supporting rapid expansion.",
        "governance_flex": "Low administrative constraints for daily management."
      },
      "explanations": {
        "DEFAULT": "Structure not very suited to your current project.",
        "EURL_SINGLE_PARTNER": "Optimal choice for a single partner wishing to limit their liability to the share capital.",
        "EURL_RECOMMENDED": "Recommended: EURL offers professional protection for your solo venture.",
        "INDIVIDUELLE_SINGLE_PARTNER": "Most flexible structure for a solo entrepreneur, without strict legal minimum capital.",
        "INDIVIDUELLE_RECOMMENDED": "Simple and direct, perfect for micro-enterprises.",
        "SARL_PME": "The standard structure for SMEs in Algeria, offering a balance between cost and protection.",
        "SARL_RECOMMENDED": "Recommended: SARL perfectly balances legal protection and flexibility for your project.",
        "SARL_VIABLE": "Viable option, but may be less optimized than the primary choice for your profile.",
        "SAS_STARTUP": "Ideal for a startup: total contractual flexibility and attractiveness for investors.",
        "SAS_SINGLE_PARTNER": "Ideal for a solo startup founder: total contractual flexibility.",
        "SAS_RECOMMENDED": "Modern and flexible, ideal for innovation and scaling.",
        "SPA_LARGE": "Designed for large-scale projects with public offerings or large capital.",
        "SPA_RECOMMENDED": "Institutional framework for high-growth or high-capital projects.",
        "SNC_TRUST": "Trust-based structure, suitable for family or artisanal projects.",
        "SNC_RECOMMENDED": "Simple structure based on mutual trust between partners.",
        "SCS_HYBRID": "Hybrid structure allowing separation of managers and financiers.",
        "SCS_RECOMMENDED": "Allows for passive investors while keeping management control.",
        "EURL_SOLO": "The EURL is the most secure vehicle for solo entrepreneurs. It allows for full control while protecting personal wealth.",
        "SARL_STANDARD": "The SARL remains the backbone of the Algerian economy. It offers a robust framework for partnerships and SMEs.",
        "SPA_INSTITUTIONAL": "Designed for large-scale operations, the SPA provides the necessary transparency and structure for institutional capital.",
        "SNC_PARTNERSHIP": "The SNC relies on the 'intuitu personae' (strong trust between partners), offering a simplified but deeply committed framework.",
        "SARL_TAX_EFFICIENT": "This configuration allows for an optimized balance between corporate taxes and partner dividends.",
        "EURL_PROTECTION": "Choosing an EURL ensures that professional risks stay within the company's capital limits.",
        "SPA_INVESTOR": "The stock-based nature of this entity is perfectly suited for complex cap-tables and future exits."
      },
      "warnings": {
        "min_partners": "Minimum partners required: {{value}}.",
        "max_partners": "Maximum partners exceeded (limit: {{value}}).",
        "low_capital_amount": "Capital below statutory minimum ({{value}} DA).",
        "high_turnover": "Turnover risk: Individual structure not recommended for high volume.",
        "high_risk": "Critical: Personal assets are exposed to company debts.",
        "no_investors": "Obstacle: This structure blocks venture capital entry."
      },
      "liability": {
        "limited": "Limited",
        "unlimited": "Unlimited",
        "limited_to_shares": "Limited to Shares"
      },
      "risk_status": {
        "low": "Secured",
        "medium": "Moderate",
        "high": "Critical"
      },
      "default_justification": "This structure offers the best balance between protection and cost."
    },
    "result": {
      "title": "Simulation Result",
      "subtitle": "Detailed analysis and legal recommendations based on your inputs.",
      "share": {
        "title": "Legal structure simulation - Charikaty",
        "text": "Discover my legal arbitration generated by Charikaty.",
        "success": "Simulation link copied to clipboard",
        "error": "Share failed"
      },
      "badge_ai": "AI POWERED",
      "pdf": {
        "generating": "Generating...",
        "download": "Download PDF Report",
        "header_subtitle": "LEGAL ARBITRATION ENGINE V2.4",
        "reference": "REFERENCE: #{{ref}}",
        "date": "DATE: {{date}}",
        "main_title": "DECISION REPORT",
        "param_header": "Parameter",
        "value_header": "Input Value",
        "section1_title": "1. EXECUTIVE SUMMARY",
        "summary_text": "Based on the algorithmic analysis of your parameters, the recommended structure is the {{fullName}} ({{name}}).",
        "match_score": "MATCH SCORE: {{score}}%",
        "tax_regime": "TAX REGIME: {{regime}}",
        "section2_title": "2. SIMULATION PARAMETERS",
        "param_partners": "Number of partners",
        "param_capital": "Share Capital",
        "param_activity": "Type of activity",
        "param_risk": "Risk Level",
        "param_objective": "Strategic Objective",
        "param_investors": "Capital opening",
        "risk_high": "High",
        "risk_medium": "Moderate",
        "risk_low": "Low",
        "yes": "YES",
        "no": "NO",
        "section3_title": "3. COMPARATIVE ANALYSIS & ADVANTAGES",
        "pros_title": "Advantages of the structure:",
        "footer": "Page {{page}} of {{total}} - Document generated by the Charikaty GSD system",
        "error": "Failed to generate PDF"
      },
      "optimal_arbitrage": "Optimal Arbitration",
      "status": "Status: {{status}}",
      "optimal_description": "{{fullName}}. This structure is the most suitable for a capital of {{capital}} DA with {{partners}} partner(s).",
      "strategic_match": "Strategic Match",
      "tax_regime": "Tax Regime",
      "liability": "Liability",
      "risk_analysis": "Risk Analysis",
      "risk_evaluation": "Compliance and exposure evaluation",
      "no_blocking_points": "No major blocking points identified.",
      "complexity_index": "Complexity Index",
      "viability_score": "Viability Score",
      "viability_trend": "+12% vs alternatives",
      "asset_protection": "Asset Protection",
      "protection_max": "Maximum",
      "protection_partial": "Partial",
      "capital_flexibility": "Capital Flexibility",
      "flexibility_total": "Total",
      "flexibility_medium": "Average",
      "scale_potential": "Scale Potential",
      "scale_high": "High",
      "scale_medium": "Moderate",
      "legal_interpretation": "Legal Interpretation",
      "legal_intro": "According to the provisions of the Algerian Commercial Code, your choice of {{name}} allows for {{liability}} liability. {{justification}}",
      "strengths": "Strengths (Alpha)",
      "weaknesses": "Constraints & Limits",
      "recommended_actions": "Recommended Actions",
      "implementation_roadmap": "Implementation Roadmap",
      "roadmap": {
        "step1_title": "Notarized Statutes",
        "step1_desc": "Draft the statutes with precise mention of the corporate purpose.",
        "step2_title": "Capital Deposit",
        "step2_desc": "Open a 'Company in formation' account for blocking.",
        "step3_title": "CNRC Registration",
        "step3_desc": "Proceed with registration within 30 days."
      },
      "start_constitution": "Launch Constitution",
      "new_simulation": "New Simulation",
      "algorithmic_confidence": "Algorithmic Confidence",
      "engine_certified": "Sovereign Engine v2.4 Certified",
      "print_report": "Print Report",
      "benchmarks": "Benchmarks",
      "benchmarks_description": "Comparative analysis with other structures",
      "match": "match",
      "arbitrage_details": "Arbitration details"
    },
    "forms": {
      "EURL": {
        "name": "EURL",
        "fullName": "Single-Member Limited Liability Company",
        "description": "The premier structure for solo entrepreneurs wishing to protect their personal assets.",
        "taxRegime": "IRG or IBS Option",
        "pros": [
          "Complete protection of personal assets",
          "Easy transformation into a SARL when partners join",
          "Choice of tax regime (IDB possible)"
        ],
        "cons": [
          "Administrative formalism (Statutes, Notary, CNRC)",
          "Full accounting obligations",
          "High setup cost (Notary + BOAL)"
        ]
      },
      "SARL": {
        "name": "SARL",
        "fullName": "Limited Liability Company",
        "description": "Ideal for family SMEs and associations of 2 to 50 people.",
        "taxRegime": "IBS",
        "pros": [
          "Maximum legal security for partners",
          "Very well known structure among Algerian banks",
          "Controlled transfer of shares (preserves family spirit)"
        ],
        "cons": [
          "Entry of new investors is complex (Approval required)",
          "Capped at 50 partners",
          "Manager is responsible in case of mismanagement"
        ]
      },
      "SPA": {
        "name": "SPA",
        "fullName": "Joint-Stock Company",
        "description": "The structure of excellence for large companies and capital projects.",
        "taxRegime": "IBS",
        "pros": [
          "Maximum credibility with key accounts/State",
          "Free and instantaneous transfer of shares",
          "Possible access to the Algiers stock exchange"
        ],
        "cons": [
          "Minimum capital of 1,000,000 DA mandatory",
          "Heavy governance (Board of Directors)",
          "Statutory auditor mandatory upon creation"
        ]
      },
      "SAS": {
        "name": "SAS",
        "fullName": "Simplified Joint-Stock Company",
        "description": "New flexible form dedicated to labeled Startups in Algeria.",
        "taxRegime": "IBS (Startup Exemptions possible)",
        "pros": [
          "Total contractual freedom of statutes",
          "Ideal for successive fundraisings",
          "Can be cumulated with the Startup label (tax benefits)"
        ],
        "cons": [
          "Reserved for startupers or labeled companies",
          "Requires very precise drafting of statutes",
          "Structure still \"young\" for some local banks"
        ]
      },
      "SNC": {
        "name": "SNC",
        "fullName": "General Partnership",
        "description": "A partnership based on total mutual trust.",
        "taxRegime": "IRG (Tax transparency)",
        "pros": [
          "No real minimum capital required",
          "No obligation to publish annual accounts",
          "Strong image of solidarity towards creditors"
        ],
        "cons": [
          "Unlimited and joint liability on personal assets",
          "Maximum risk: if one partner goes bankrupt, all pay",
          "Difficult to leave the company without unanimous agreement"
        ]
      },
      "INDIVIDUELLE": {
        "name": "Sole Proprietorship / Freelance",
        "fullName": "Sole Proprietorship (Natural Person)",
        "description": "The absolute administrative simplicity for starting alone.",
        "taxRegime": "IFU (Single Flat Tax)",
        "pros": [
          "Instant creation at the CNRC (just a card)",
          "Almost zero management cost",
          "Super-simplified accounting"
        ],
        "cons": [
          "Personal and professional assets are mixed",
          "Impossible to have partners later",
          "Limited credibility for large contracts"
        ]
      }
    }
  },
  "name_check": {
    "title": "Brand Validation",
    "subtitle": "Multi-vector comparative analysis to secure your business identity.",
    "brand_arbitrage": "Brand Arbitrage",
    "description": "Expert system for availability verification and legal confusion risk analysis according to CNRC standards.",
    "multi_layer_audit": "Multi-Layer Audit",
    "check_1": "Central Registry Availability",
    "check_2": "Phonetic & Visual Similarity",
    "check_3": "Arabic/FR Lexical Compliance",
    "check_4": "Brand Protection Analysis",
    "step1_label": "Desired Denomination",
    "name_placeholder": "EX: ALGERIA TECH SOLUTIONS",
    "step2_label": "Activity Sector",
    "sectors": {
      "tech": "Technology & Digital",
      "telecom": "Telecommunications",
      "finance": "Banking & Finance",
      "industry": "Industry & Energy",
      "construction": "Construction & Civil Engineering",
      "services": "Business Services",
      "health": "Health & Pharma",
      "trade": "Trade & Distribution",
      "agro": "Food & Agro-industry",
      "other": "Other Sectors"
    },
    "step3_label": "Project Details (Optional)",
    "details_placeholder": "Briefly describe the activity to refine risk analysis...",
    "analyze_button": "Launch LegalEngine Audit",
    "checking": "Audit in progress...",
    "database_info": "Synchronized CNRC Database",
    "compliance_guarantee": "Guaranteed Compliance Check",
    "connected_to": "Connected to",
    "central_registry": "Central Commercial Registry",
    "errors": {
      "reserved": "This name is currently reserved in your active session."
    },
    "engine": {
      "explanation": {
        "unavailable": "This name presents a direct conflict or critical similarity with an existing entity in the CNRC.",
        "risky": "Name available but presenting moderate confusion risks. A slight modification is advised.",
        "available": "Excellent availability. No major conflict detected in the selected sector."
      }
    },
    "results": {
      "title": "Analysis Results",
      "availability": "Availability",
      "risk_level": "Risk Level",
      "recommendation": "Recommendation",
      "risk_levels": {
        "low": "Low Risk",
        "medium": "Moderate Risk",
        "high": "High Risk"
      },
      "distinctiveness_levels": {
        "high": "High Distinctiveness",
        "low": "Low Distinctiveness"
      },
      "metrics": {
        "phonetic": "Phonetic",
        "phonetic_value": "{{percent}}% Match",
        "visual": "Visual",
        "visual_value": "{{percent}}% Match"
      },
      "recommendations": {
        "ACCEPT": "Accept",
        "MODIFY": "Modify",
        "REJECT": "Reject"
      }
    }
  },
  "name_result": {
    "title": "Sentinel Audit Report",
    "subtitle": "Eligibility and brand protection analysis.",
    "status_valid": "Valid / Available",
    "status_invalid": "Unavailable / Risky",
    "compiling": "Compiling Analysis...",
    "recommended_action": "Recommended Action",
    "digital_assets": "Digital Assets & Domains",
    "footer_advisory": "This report is generated for informational purposes by LegalEngine and does not replace the official CNRC certificate.",
    "summary": {
      "title": "Audit Summary",
      "subtitle": "Deep linguistic and legal analysis",
      "score": "Score",
      "legal_risk": "Legal Risk",
      "phonetic": "Phonetic Conflict",
      "visual": "Visual Conflict",
      "metric": "Metric",
      "description": "Description",
      "class": "Class",
      "sector": "Sector",
      "distinctiveness": "Force Distinctive"
    },
    "conflicts": {
      "title": "Conflict Analysis",
      "entity": "Entity",
      "similarity": "Similarity",
      "sector": "Sector",
      "registered": "CNRC Registered",
      "match": "Match"
    },
    "decision": {
      "title": "Sentinel Decision"
    },
    "domains": {
      "free": "Free",
      "taken": "Taken",
      "global_asset": "Global Asset"
    },
    "actions": {
      "new_search": "New Search",
      "reserve": "Reserve this Name",
      "excel": "Excel Audit",
      "pdf": "PDF Report",
      "download_pdf": "Télécharger Rapport PDF",
      "download_excel": "Exporter Données"
    },
    "metrics": {
      "memorability": "Memorability",
      "memorability_desc": "Ability of the audience to remember the name.",
      "protection": "Protection Index",
      "protection_desc": "Ease of legal defense for the brand.",
      "availability": "Immediate Availability",
      "availability_desc": "Current status in the national registry."
    },
    "similarity": "Similarity",
    "engine_status": "Sentinel v4.2 • LegalEngine Active",
    "analysis": {
      "title": "Analyse Détaillée Sentinel",
      "description": "Notre moteur d'IA analyse le nom proposé par rapport aux registres du commerce et marques déposées."
    },
    "toasts": {
      "reserve_success_title": "Nom Réservé",
      "reserve_success_msg": "Le nom est désormais réservé pour votre projet."
    }
  },
  "create": {
    "title": "Company Creation",
    "subtitle": "Launch your structure with institutional precision.",
    "steps": {
      "founder": "Founder",
      "structure": "Structure",
      "review": "Review"
    },
    "buttons": {
      "next": "Next Step",
      "back": "Back",
      "submit": "Submit Application"
    }
  },
  "statutes": {
    "title": "Digital Statutes Generation",
    "subtitle": "IA LegalEngine Certified Statutes",
    "sections": {
      "social_object": "Social Object",
      "share_capital": "Share Capital",
      "duration": "Duration",
      "headquarters": "Head Office",
      "governance": "Governance",
      "fiscal_year": "Fiscal Year",
      "liquidation": "Liquidation",
      "partners": "Partners & Contributions"
    },
    "actions": {
      "download_pdf": "Download Statutes (PDF)",
      "edit": "Edit Data",
      "validate": "Validate at Notary"
    },
    "metadata": {
      "jurisdiction": "Jurisdiction",
      "framework": "Legal Framework",
      "algeria": "Algeria",
      "commercial_code": "Commercial Code 2024",
      "certified_by": "Certified by Charikaty GSD"
    }
  },
  "statutes_generator": {
    "title": "Statutes Configuration",
    "subtitle": "Define the legal parameters and ownership structure of your company.",
    "sections": {
      "structure": "Structure & Identity",
      "governance": "Governance & Administration",
      "capital": "Capital & Ownership",
      "compliance": "Compliance Check"
    },
    "fields": {
      "legal_form": "Proxy Legal Form",
      "company_name": "Company Name",
      "company_name_placeholder": "E.G.: SARL ALPHA DZ",
      "activity": "Social Object (Main Activity)",
      "activity_placeholder": "Describe the main economic activity...",
      "address": "Head Office (Full Address)",
      "address_placeholder": "Address, City, Province",
      "manager_name": "Legal Representative Name",
      "manager_placeholder": "Manager or President",
      "powers": "Scope of Powers",
      "powers_standard": "Extended Powers (Standard)",
      "powers_limited": "Current Management Only",
      "powers_secured": "Co-signature (Secured)",
      "powers_standard_text": "The broadest powers to act on behalf of the company.",
      "powers_limited_text": "Powers limited to current management acts.",
      "powers_secured_text": "Co-signature required for any act > 500,000 DA.",
      "capital": "Share Capital (DA)",
      "share_value": "Nominal Value (DA)",
      "partners_list": "List of Partners",
      "partner_badge": "Partner {{index}}",
      "partner_name_placeholder": "FULL NAME",
      "partner_id_placeholder": "ID NUMBER",
      "risk_level": "Risk Aversion",
      "risk_prudent": "PRUDENT",
      "risk_moderate": "MODERATE",
      "risk_aggressive": "AGGRESSIVE",
      "threshold": "Control Threshold (DA)",
      "spas_options": "Specific SPAS Options"
    },
    "validations": {
      "compliant": "Valid Structure",
      "correction": "Correction Required",
      "success_msg": "Legal architecture complies with CNRC requirements.",
      "name_required": "Company name required",
      "name_short": "Name too short for CNRC",
      "capital_zero": "Capital must be greater than 0",
      "shares_mismatch": "Inconsistent distribution: {{total}}% (Must be 100%)",
      "eurl_unipersonal": "EURL is strictly unipersonal",
      "spa_capital_min": "Minimum capital for a SPA is 1,000,000 DA",
      "spa_partners_min": "A SPA requires at least 7 shareholders",
      "sarl_partners_max": "A SARL cannot exceed 50 partners",
      "manager_required": "Legal representative (Manager/President) required"
    },
    "buttons": {
      "reset": "Reset",
      "generate": "Generate Document",
      "balance": "Balance",
      "add_partner": "Add"
    },
    "toasts": {
      "processing_title": "Processing",
      "processing_msg": "Generating official statutes...",
      "error_title": "Error",
      "error_msg": "Generation failed.",
      "success_title": "Données Générées",
      "success_msg": "Le projet de statuts a été préparé avec succès."
    },
    "defaults": {
      "activity": "NÉGOCE ET SERVICES",
      "role": "Actionnaire",
      "category_founder": "FONDATEUR",
      "role_manager": "Gérant"
    },
    "actions": {
      "reset": "Réinitialiser",
      "generate": "Générer les documents"
    },
    "company_data": "Données de la Société",
    "legal_form_label": "Forme Juridique",
    "company_name_label": "Dénomination Sociale",
    "company_name_placeholder": "Ex: TechNova Solutions...",
    "activity_label": "Objet Social (Activités)",
    "activity_placeholder": "Décrivez l'activité de la société en détail...",
    "address_label": "Siège Social",
    "address_placeholder": "Adresse complète et Wilaya...",
    "validation": {
      "required": "Ce champ est obligatoire",
      "shares_sum": "La somme des parts doit être de 100% (Actuellement: {{total}}%)",
      "min_capital": "Le capital minimum pour cette forme est de {{min}} DA"
    },
    "setup": "Article"
  },
  "compliance": {
    "title": "Compliance Module",
    "subtitle": "Real-time monitoring of your regulatory status.",
    "status": {
      "title": "Compliance Status",
      "compliant": "Compliant",
      "non_compliant": "Non-Compliant",
      "at_risk": "At Risk",
      "risk_negligible": "Negligible",
      "risk_critical": "Critical",
      "risk_moderate": "Moderate",
      "risk_level": "Risk Level: {{level}}",
      "access_registry": "Access Registry",
      "health_index": "Health Index",
      "active_alerts": "Active Alerts",
      "immediate_attention": "Immediate attention required",
      "next_deadlines": "Next Deadlines",
      "current_cycle": "Current Cycle"
    },
    "registry": {
      "title": "Obligation Registry",
      "filter_placeholder": "Filter obligations...",
      "priority": "Priority",
      "deadline": "Deadline",
      "penal_risk": "Penal Risk",
      "action_start": "Start",
      "actionLabel": "Start"
    },
    "tasks": {
      "title": "Obligation",
      "social_accounts": {
        "title": "Filing of Social Accounts",
        "desc": "Mandatory annual filing of accounts with the CNRC before June 30.",
        "basis": "Art. 717 of the Commercial Code",
        "penalty": "Fines and RC blockage"
      },
      "g50": {
        "title": "G50 Declaration (Monthly)",
        "desc": "Declaration and payment of taxes (TAP, TVA, IRG, IBS).",
        "basis": "Direct Tax Code",
        "penalty": "Late payment penalties (10-25%)"
      },
      "bank_dossier": {
        "title": "Bank Dossier Update",
        "desc": "Renewal of KYC documents with your bank.",
        "basis": "Regulation 02-11 of the Bank of Algeria",
        "penalty": "Freezing of bank operations"
      },
      "ago": {
        "title": "Annual General Meeting (AGO)",
        "desc": "Ordinary General Meeting for the approval of accounts.",
        "basis": "Art. 675 of the Commercial Code",
        "penalty": "Nullity of corporate decisions"
      },
      "das": {
        "title": "DAS Declaration (Annual)",
        "desc": "Annual Declaration of Salaries and social contributions.",
        "basis": "Law 83-14 relating to Social Security",
        "penalty": "Fines per undeclared employee"
      }
    },
    "form": {
      "title": "Title",
      "description": "Description",
      "category": "Category",
      "placeholder_title": "e.g. CASNOS Contribution",
      "placeholder_desc": "Enter obligation details..."
    },
    "priorities": {
      "CRITIQUE": "CRITICAL",
      "HAUTE": "HIGH",
      "MOYENNE": "MEDIUM",
      "FAIBLE": "LOW"
    },
    "categories": {
      "JURIDIQUE": "LEGAL",
      "FISCAL": "FISCAL",
      "SOCIAL": "SOCIAL",
      "ADMIN": "ADMIN"
    },
    "audit": {
      "title": "Traceability & Audit",
      "validated_event": "Validated Event",
      "agent": "Agent: {{user}}",
      "id": "AUDIT REFERENCE",
      "empty": "No audit history available",
      "download": "Download Report",
      "system_init": "Compliance System Initialized",
      "baseline_scan": "Baseline regulatory scan completed"
    },
    "toasts": {
      "admin": "System Administrator",
      "resolved_title": "Obligation Resolved",
      "resolved_msg": "The obligation has been marked as completed. Ref: {{ref}}",
      "added": "New obligation added to the registry",
      "log_msg": "Action performed: {{title}}"
    },
    "intelligence": {
      "title": "Regulatory Intelligence",
      "real_time": "REAL-TIME",
      "break_point": "Break point detected",
      "break_point_desc": "Your compliance score is <1>below 60%</1>. Immediate regularization of the <3>Bank Dossier</3> is imperative.",
      "start_regularization": "Start Regularization",
      "secure_perimeter": "Secure Perimeter",
      "secure_desc": "No critical anomalies detected. Your structure is in full compliance with current regulations."
    },
    "nav": {
      "overview": "Overview",
      "registry": "Registry",
      "intelligence": "Intelligence"
    }
  },
  "statutes_result": {
    "title": "Institutional Document Management",
    "subtitle": "Certified generation and legal vault management.",
    "actions": {
      "print": "Print",
      "download_pdf": "Download PDF",
      "share": "Share via Link",
      "archive": "Archive in Vault",
      "export_excel": "Export to Excel",
      "advanced_options": "Advanced Options",
      "view_docs": "View Documentation"
    },
    "status": {
      "document_state": "Document Status",
      "cnrc_compliant": "CNRC COMPLIANT",
      "automated": "Automated Generation",
      "accuracy": "Legal Accuracy Score",
      "legal_notice": "Legal Notice",
      "legal_notice_text": "This document was generated via the LegalDZ AI engine. It respects the standard clauses of the Algerian executive decree relating to typical statutes.",
      "legal_notice_warning": "This document constitutes a certified draft of statutes. It must be authenticated by a licensed notary to acquire full legal value.",
      "end_of_document": "End of Document"
    },
    "signature": {
      "mention_approved": "Mention \"Read and Approved\"",
      "partner_initials": "Partners' Initials",
      "company_seal": "Company Seal",
      "manager_signature": "Manager's Signature"
    },
    "placeholders": {
      "name": "[NAME]",
      "activity": "[ACTIVITY]",
      "address": "[ADDRESS]",
      "representative": "[REPRESENTATIVE]"
    },
    "initial_data": {
      "activity": "Trading & Services",
      "complexity": "Moderate",
      "automation": "Advanced",
      "type": "Form",
      "capital": "Capital",
      "partners": "Partners",
      "complexity_label": "Complexity",
      "automation_label": "Automation"
    },
    "articles": {
      "standard": {
        "art1_title": "FORM",
        "art1_content": "The company is a {{form}}, governed by the laws in force in Algeria, notably the Commercial Code.",
        "art2_title": "COMPANY NAME",
        "art2_content": "The company's name is: {{name}}. It is followed by the mention \"{{form}}\".",
        "art3_title": "REGISTERED OFFICE",
        "art3_content": "The registered office is fixed at: {{address}}. It may be transferred to any other location in the national territory by simple decision of the management.",
        "art4_title": "CORPORATE PURPOSE",
        "art4_content": "The company's main purpose is: {{activity}}.",
        "art5_title": "SHARE CAPITAL AND DISTRIBUTION",
        "art5_content": "The share capital is fixed at {{capital}} DA, divided into {{count}} shares of {{value}} DA each.",
        "art6_title": "MANAGEMENT AND ADMINISTRATION",
        "art6_content": "The company is managed by {{manager}}. {{powers}}",
        "art7_title": "CONTROL",
        "art7_content": "Management control is exercised in accordance with current legal provisions.",
        "art8_title": "GENERAL MEETINGS",
        "art8_content": "Collective decisions are made in ordinary or extraordinary general meetings.",
        "art9_title": "FISCAL YEAR",
        "art9_content": "The fiscal year begins on January 1st and ends on December 31st of each year.",
        "art10_title": "ALLOCATION OF PROFITS",
        "art10_content": "Net profits are distributed among partners in proportion to their shares.",
        "art11_title": "DISSOLUTION AND LIQUIDATION",
        "art11_content": "At the expiration of the company, the general meeting settles the mode of liquidation."
      },
      "spas": {
        "art1_title": "CONSTITUTION AND LEGAL FORM",
        "art1_content": "The structure is constituted as a Joint Stock Company (SPA), governed by the Algerian Commercial Code. It adopts the SPAS (Secured Private Shareholding Structure) governance protocol to ensure maximum protection for investors and founders of {{name}}.",
        "art2_title": "ECONOMIC AND STRATEGIC PURPOSE",
        "art2_content": "The structure's mission is value creation via: {{activity}}. It aims to optimize investment flows and secure assets.",
        "art3_title": "CAPITAL ORGANIZATION (MULTI-LEVEL)",
        "art3_content": "The capital is structured in several priority levels, totaling {{capital}} DA, divided into shares of {{value}} DA.",
        "art4_title": "INVESTOR CATEGORIES",
        "art4_content": "Participants are divided into: Founders, Investors, and Partners. Current distribution: {{partners}}.",
        "art5_title": "DIFFERENTIATED RIGHTS OF PARTICIPANTS",
        "art5_content": "Voting rights and dividends are modulated by category to ensure increased protection for top-tier investors.",
        "art6_title": "MODULAR GOVERNANCE SYSTEM",
        "art6_content": "Governance is agile, with complexity defined as \"{{complexity}}\". It separates executive direction from strategic validation.",
        "art7_title": "MANAGEMENT AND VALIDATION COMMITTEE",
        "art7_content": "Any major decision exceeding {{threshold}} DA must be validated by the parity Management Committee.",
        "art8_title": "CONTROL MECHANISMS AND RISK MANAGEMENT",
        "art8_content": "A permanent audit system is established. The target risk level of the structure is maintained at: {{risk}}.",
        "art9_title": "ENTRY AND EXIT RULES",
        "art9_content": "Entry of new investors is subject to approval. Exit is framed by priority Buy-Back clauses.",
        "art10_title": "ALLOCATION OF RESULTS AND DISTRIBUTION",
        "art10_content": "Distribution follows a payment cascade (Waterfall) prioritizing capital return for external investors.",
        "art11_title": "INTERNAL LEGAL PROTECTION SYSTEMS",
        "art11_content": "Mandatory mediation before arbitration. Reinforced confidentiality and non-competition clauses for strategic partners.",
        "art12_title": "DISSOLUTION AND RESTRUCTURING",
        "art12_content": "In case of dissolution, the bonus is distributed according to the priority order of Article 10. Any restructuring preserves acquired rights."
      }
    },
    "pdf": {
      "institutional_header": "PEOPLE'S DEMOCRATIC AND POPULAR REPUBLIC OF ALGERIA",
      "ministry_header": "MINISTRY OF COMMERCE AND EXPORT PROMOTION",
      "main_title": "CONSTITUTIVE STATUTES",
      "generation_date": "Generation date",
      "ref": "Ref",
      "filename_prefix": "Statutes_",
      "footer_text": "This document is generated electronically and certified by the Charikaty Legal DZ platform.",
      "company_name": "Name",
      "legal_form": "Form",
      "headquarters": "Headquarters",
      "capital": "Capital",
      "partners_table": {
        "name": "Partner Name",
        "identity": "Identity Card",
        "shares": "Shares",
        "contribution": "Contribution (DA)"
      },
      "currency": "دج"
    },
    "excel": {
      "filename": "statutes-{{name}}.xlsx",
      "sheet_name": "Company Statutes",
      "headers": {
        "article": "Article",
        "title": "Title",
        "content": "Content"
      },
      "report_title": "STATUTES - STRUCTURED DATA"
    },
    "toasts": {
      "archived_title": "Document Archived",
      "archived_msg": "Document saved in your secure legal vault.",
      "shared_title": "Link Copied",
      "shared_msg": "The sharing link has been copied to the clipboard.",
      "pdf_ready_title": "Document Ready",
      "pdf_ready_msg": "The institutional PDF file has been generated.",
      "export_ready_title": "Export Successful",
      "export_ready_msg": "Data has been exported to Excel.",
      "error_gen": "PDF generation failed.",
      "error_export": "Excel export failed.",
      "error_archive": "Archiving failed.",
      "error_no_data": "Generation data not found."
    }
  },
  "documentation_modal": {
    "title": "Legal Documentation",
    "subtitle": "Algeria Compliance Guide v2024.1",
    "search_placeholder": "Search for an article...",
    "warning_title": "Warning",
    "warning_text": "This information is provided for guidance only and does not replace the advice of a licensed legal expert.",
    "help_title": "Need help?",
    "help_text": "Contact our specialized legal support.",
    "open_ticket": "Open a Ticket",
    "certified": "Certified by Charikaty Legal",
    "download_guide": "Download PDF Guide",
    "sections": {
      "legal_framework": {
        "title": "Algerian Legal Framework",
        "items": {
          "commerce": "Commercial Code: Articles 544 and following define the social forms.",
          "decree": "Executive Decree n° 97-40: Relating to company constitution criteria.",
          "startup": "Law n° 22-09: Relating to the self-entrepreneur and startups (SAS)."
        }
      },
      "notary_role": {
        "title": "Role of the Notary",
        "items": {
          "auth": "Authentication: All constitutive acts must be signed before a notary.",
          "deposit": "Legal Deposit: The notary ensures the deposit of statutes at the CNRC.",
          "publicity": "Legal Publicity: Mandatory insertion in the BOAL."
        }
      },
      "cnrc_steps": {
        "title": "Steps at the CNRC",
        "items": {
          "name": "Denomination: Obtaining the negative certificate.",
          "registration": "Registration: Submission of the complete file to the CNRC.",
          "card": "Magnetic Card: Issuance of the final commercial register."
        }
      }
    }
  },
  "creation": {
    "title": "Company Creation",
    "description": "Workflow for registration and constitution of new legal entities.",
    "pipeline": "Venture Pipeline",
    "immatriculation": "Registration",
    "expert_advice": {
      "title": "Expert Advice",
      "text": "\"Registration officially takes place 48 hours after notarized signature.\""
    },
    "steps": {
      "identity": {
        "title": "Identity",
        "desc": "Name & Type"
      },
      "headquarters": {
        "title": "Headquarters",
        "desc": "Location"
      },
      "governance": {
        "title": "Governance",
        "desc": "Shareholding"
      },
      "validation": {
        "title": "Validation",
        "desc": "Legal Audit"
      }
    },
    "step1": {
      "title": "Legal Identity",
      "subtitle": "Define the legal personality of your company.",
      "name_label": "Trade Name",
      "name_reserved": "Reserved Name",
      "name_placeholder": "EX: ALGERIA TECH HUB",
      "form_label": "Legal Form",
      "common_hint": "(Most common)",
      "selected_via_simulator": "Selected via simulator",
      "sector_label": "Statutory Sector",
      "sector_placeholder": "EX: DIGITAL SERVICES"
    },
    "step2": {
      "title": "Headquarters & Capital",
      "subtitle": "Real estate reality and financial consistency of the project.",
      "wilaya_label": "Registration Wilaya",
      "address_label": "Detailed Address (Local)",
      "address_placeholder": "NUMBER, STREET, NEIGHBORHOOD, MUNICIPALITY...",
      "address_hint": "Must match the lease agreement (notarized or private).",
      "capital_label": "Share Capital (DZD)",
      "min_legal": "Legal Minimum",
      "capital_hint": "For a <1>{{type}}</1>, the capital deposit must be justified by a bank certificate.",
      "capital_guarantee": "Capital Guarantee",
      "capital_guarantee_desc": "Share capital determines the liability of partners up to their contributions."
    },
    "step3": {
      "title": "Governance",
      "subtitle": "Capital architecture and designation of managers.",
      "new_associate": "+ New Partner",
      "associate_name": "Partner Name",
      "name_placeholder": "FIRST & LAST NAME",
      "identity_label": "Identity (NIN / Passport)",
      "identity_placeholder": "ID NUMBER",
      "shares_label": "Shares (%)",
      "executive_role": "Executive Role",
      "roles": {
        "gerant": "Main Manager",
        "associe": "Simple Partner",
        "dg": "General Manager (DG)"
      },
      "cap_table_title": "Cap Table Analytics",
      "total_distributed": "Total Distributed",
      "shares_warning": "The total shares must be strictly equal to 100% for the signing of the statutes."
    },
    "step4": {
      "title": "Audit & Validation",
      "subtitle": "Final verification before the generation of legal acts.",
      "compliance_rate": "Compliance",
      "summary": {
        "identity": "Identity",
        "capital": "Capital",
        "capital_desc": "Full Contribution",
        "governance": "Shareholding",
        "governance_desc": "Management: {{manager}}"
      },
      "report_title": "Sentinel Report",
      "compliance_note": {
        "title": "Compliance Note",
        "engine": "Sentinel Engine v2024.1",
        "description": "\"The selected configuration complies with articles 544 and following of the Algerian Commercial Code. Electronic signature will be available upon validation of this workflow.\""
      },
      "audit_summary": {
        "title": "Institutional Audit",
        "health": "Legal Health Index",
        "hint": "The index evaluates regulatory compliance and personal asset protection."
      },
      "legal_note": {
        "title": "Legal Note",
        "desc": "The generated statutes will strictly follow the provisions of the Algerian Commercial Code 2024."
      },
      "status": {
        "in_progress": "Audit in Progress",
        "hint": "The Institutional Audit is performed automatically at the validation step."
      }
    },
    "footer": {
      "previous": "Previous",
      "next": "Next",
      "submit": "Finalize Creation",
      "progress": "Pipeline Progress"
    },
    "audit_labels": {
      "denomination": "Denomination",
      "structure": "Partner Structure",
      "capital": "Share Capital",
      "distribution": "Capital Proration",
      "ready_audit": "Ready for audit",
      "required": "Required",
      "validated": "Validated & Reserved",
      "partners_ok": "{{count}} Partners (OK)",
      "partners_range": "Min: {{min}}, Max: {{max}}",
      "capital_ok": "Code Compliant",
      "capital_req": "Min: {{min}} DZD required",
      "distribution_ok": "Balanced distribution",
      "distribution_fail": "Total: {{total}}%"
    }
  },
  "creation_result": {
    "title": "Creation Summary",
    "description": "Constitution file validated and certified by Charikaty Legal Sentinel.",
    "success_header": "Process initialized",
    "entity_ready": "Your legal entity <1>{{name}}</1> is ready for registration.",
    "certified_dossier": "Certified File",
    "default_activity": "GENERAL SERVICES",
    "country": "ALGERIA",
    "legal_form_label": "Legal Form",
    "capital_label": "Share Capital",
    "associates_table_title": "Partners Table",
    "members_count": "{{count}} Members",
    "compliance_title": "Legal Compliance",
    "audit_ref": "Audit Reference",
    "cnrc_verification": "CNRC Verification",
    "certified": "Certified",
    "wilaya": "Wilaya",
    "complete_dossier": "Complete File",
    "complete_dossier_desc": "All required elements for registration are validated.",
    "next_steps_title": "Next Steps",
    "steps": {
      "statutes": {
        "title": "Statutes Generation",
        "desc": "Automatic drafting of the constitutive statutes."
      },
      "notary": {
        "title": "Notarized Signature",
        "desc": "Appointment at the notary (Algiers Center)."
      },
      "cnrc": {
        "title": "CNRC Registration",
        "desc": "Obtaining the final Commercial Register."
      }
    },
    "legal_note_title": "Legal Note",
    "legal_note_desc": "This summary constitutes a pre-registration audit. The generated statutes will comply with the Algerian Commercial Code v2024.",
    "actions": {
      "modify": "Modify",
      "pdf": "PDF",
      "generate": "Generate Statutes"
    }
  },
  "creation_success": {
    "title": "Institutional Success",
    "subtitle": "Your legal architecture has been successfully generated and validated by the LegalEngine engine.",
    "badge": "CERTIFIED BY CHARIKATY",
    "summary_title": "Constitution Summary",
    "company_name": "Denomination",
    "legal_form": "Legal Form",
    "capital_label": "Share Capital",
    "associates_table_title": "Partners Table",
    "members_count": "{{count}} Members",
    "compliance_title": "Legal Compliance",
    "audit_ref": "Audit Reference",
    "cnrc_verification": "CNRC Verification",
    "certified": "Certified",
    "wilaya": "Wilaya",
    "complete_dossier": "Complete File",
    "complete_dossier_desc": "All required elements for registration are validated.",
    "next_steps_title": "Next Steps",
    "steps": {
      "statutes": {
        "title": "Statutes Generation",
        "desc": "Automatic drafting of the constitutive statutes."
      },
      "notary": {
        "title": "Notarized Signature",
        "desc": "Appointment at the notary (Algiers Center)."
      },
      "cnrc": {
        "title": "CNRC Registration",
        "desc": "Obtaining the final Commercial Register."
      }
    },
    "legal_note_title": "Legal Note",
    "legal_note_desc": "This summary constitutes a pre-registration audit. The generated statutes will comply with the Algerian Commercial Code v2024.",
    "actions": {
      "modify": "Modify",
      "pdf": "PDF",
      "generate": "Generate Statutes"
    }
  }
}